import { configureStore } from "@reduxjs/toolkit";
import ReduxChild from "./ReduxChild";

export const store = configureStore({
  reducer: {
    counter: ReduxChild,
  },
});
